<template>
    <template v-if="status === 'addToCart'">
        <button class="button add-to-cart js-ga-event js-add-to-cart"
                :class="{ 'product-detail': onDetail}"
                @click="add"
                :data-page-area="dataPageArea"
                data-type="button"
                data-name="add-to-cart"
                :data-text="btnText"
                data-action="modal"
                :data-destination-url="`/kosik/pridat-do-kosika/${productIdP}`"
                data-lb-action="buy"
                :data-id="productIdP"
        >
            {{ btnText }}
            <img src="/img/icons/cart.svg" v-svg-inline>
        </button>
    </template>
    <template v-else>
        <a :href="'/kosik/odstranit/' + productIdP" class="button remove-from-cart">
            <span class="static">
                {{ btnTextInCart }}
                <img src="/img/icons/checked-black.svg" alt="">
            </span>
            <span class="hover">
                {{ btnTextRemove }}
            </span>
        </a>
    </template>
</template>

<script>
import { inject, onMounted, reactive, toRefs } from 'vue'
import axios from 'axios'

import { isJson } from '../../functions/helpers'

export default {

    props: [
        'productIdP',
        'btnText',
        'btnTextInCart',
        'btnTextRemove',
        'shouldChangeStatus',
        'cartProduct',
        'discounted',
        'discountPercentage',
        'in_cart',
        'dataPageArea',
        'gtmDataP',
        'onDetail'
    ],

    setup(props) {

        const state = reactive({
            quantity: 1,
            productId: props.productIdP,
            status: 'addToCart',
            type: 'product',
            gtmData: null,
        })

        const emitter = inject('emitter')

        onMounted( () => {

            if ( isJson(props.gtmDataP) ) {
                state.gtmData = JSON.parse(props.gtmDataP)
            } else {
                state.gtmData = props.gtmDataP
            }

            // type cartProduct su produkty pridane v kosiku ktore su zvyhodnene cenovo
            if ( props.shouldChangeStatus ) {
                state.type = 'cartProduct'
            }

            emitter.on('update-quantity', (quantity) => {
                state.quantity = quantity
                state.gtmData.items[0].quantity = quantity.value
            })

            emitter.on('on-variation-set', ({ product_id }) => {
                state.productId = product_id
            })

            if (props.in_cart == 1) {
                state.status = 'removeFromCart'
            }
        })

        function add() {

            if ( props.onDetail ) {
                let discountFlag = 0
                let discountPercentage = 0

                if ( props.discounted == 1 ) {
                    discountFlag = 1
                    discountPercentage = props.discountPercentage
                }

                axios.post(`/kosik/pridat-do-kosika/${state.productId}`, {
                    quantity: state.quantity,
                    type: state.type,
                    discountFlag: discountFlag,
                    discountPercentage: discountPercentage,
                }).then( response => {
                    emitEvent(response)

                    if ( response.data.status === 'success' ) {

                        if ( discountFlag == 1 ) {
                            window.location.reload()
                        } else {
                            emitter.emit('product-added', response.data.cartItem)
                            emitter.emit('update-basket', response.data)
                        }

                        if ( props.shouldChangeStatus ) {
                            state.status = 'inCart'
                        }
                    } else if ( response.data.status === 'error' ) {
                        flash(response.data.message, 'danger')
                    } else flash('Nasala neočakávaná chyba. Kontaktuje podporu.', 'danger')
                }).catch( error => flash(error.message, 'danger') )
            } else {
                emitEvent()
            }
        }

        const emitEvent = () => {
            emitter.emit('track-event', {
                data: state.gtmData,
                event: 'addToCart'
            })
        }

        return {
            ...toRefs(state),
            add,
        }
    }
}
</script>
